<template>
    <div id="app">
        <Navbar />
        <router-view/>
        <PageFooter />
    </div>
</template>

<script>
    import Navbar from './components/Navbar';
    import PageFooter from './components/Footer';

    export default {
        name: 'App',
        components: {
            Navbar,
            PageFooter
        },
    }
</script>

<style>
    #app {
        height: 100%;
        font-size: 1.2rem;
    }
    .card {
        box-shadow: none;
        z-index: 1;
    }
    h1, h2, h3, h4, h5, h6, p, img {
        z-index: 1;
    }
    img {
        -webkit-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    @media (max-width: 768px) {
        .page-top {
            height: 85vh !important;
        }
        .pill-1 {
            height: 760px !important;
            width: 800px !important;
            border-radius: 780px !important;
            z-index: -1000 !important;
            -webkit-transform: rotate(0deg) !important;
            transform: rotate(0deg) !important;
            right: -170px !important;
            top: 100px !important;
        }
    }
</style>
